import React, { useEffect, useState } from "react";
import clg from "./log";

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width : window.innerWidth,
          height : window.innerHeight,
        });
      }

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Add event listener
      window.addEventListener("resize", handleResize);
      
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, [window.innerWidth, window.innerHeight]);
    return windowSize;
}

export default useWindowSize;